<div class="note-caption" [ngClass]="{ new: isNew }">
  {{ getHeader() }}<span *ngIf="isResolutionNote && isNoteRequiredOnResolve" class="note-caption-required">*</span>
</div>

<div class="note-header">
  <ng-container *ngIf="!isNew">
    <div
      class="note-header-caption"
      [soti-tooltip]="editText.split('by_label' | xsI18n)[1]"
      placement="top"
      [delay]="500"
      sa-ellipsis-text
    >
      {{ editText }}
    </div>
    <div class="existing-uploaded-pipe"><span class="subtext-gray">|</span></div>
    <div *ngIf="!isNew" class="note-header-creation-date">
      <span class="activity-updating-time-regular" *ngIf="isResolutionNote; then updateDate; else creationDate"></span>
      <ng-template #creationDate>
        <xs-updating-time [hidespan]="true" [time]="activity.creationDate"></xs-updating-time>
      </ng-template>
      <ng-template #updateDate>
        <xs-updating-time [hidespan]="true" [time]="activity.updateDate"></xs-updating-time>
      </ng-template>
    </div>
  </ng-container>
</div>

<!-- Text Edit -->
<xs-note
  [noteActivity]="activity"
  [activityCtrl]="activityCtrl"
  (updatePrivacy)="updatePrivacy($event)"
  (updateEditing)="updateEditing($event)"
  (saveNote)="saveNote($event)"
  [error]="error"
  [disable]="disableNote"
></xs-note>
<div class="information-container" *ngIf="isResolutionNote && !activity.description && showResolutionNoteWarning">
  <span class="information-content">{{ 'resolution_note_worning' | xsI18n }}</span>
</div>
